
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useEffect } from "react";
import { useRouter } from "next/router";
import { Turnstile } from "@marsidev/react-turnstile";

const TurnstilePage = () => {
  const router = useRouter();
  const { ip } = router.query;
  console.log("ip", ip);

  useEffect(() => {
    if (typeof window !== "undefined" && window.parent) {
      window.addEventListener("message", (event) => {
        if (event.data === "reset") {
          // Handle reset if needed
        }
      });
    }
  }, []);

  const handleSuccess = async (token: string) => {
    try {
      // Verify Turnstile and delete Crowdsec Decision if successful
      // Pass IP in the body
      const body = {
        token,
        ip,
      };
      const response = await fetch("/api/verify-turnstile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.success) {
        // Only send the token to parent if verification was successful
        window.parent.postMessage(
          {
            type: "turnstile-success",
            token,
            verified: true,
          },
          "*"
        );
        // const url = new URL(window.location.href);
        // const redirectUrl = url.searchParams.get("url")
        //   ? "https://" + url.searchParams.get("url")
        //   : null;
        // console.log("url", redirectUrl);
        // if (redirectUrl) {
        //   console.log("pushing url", redirectUrl);
        //   window.location.replace(redirectUrl);
        // }
      } else {
        window.parent.postMessage(
          {
            type: "turnstile-error",
            error: "Verification failed",
          },
          "*"
        );
      }
    } catch (error) {
      console.error("Verification error:", error);
      window.parent.postMessage(
        {
          type: "turnstile-error",
          error: "Verification failed",
        },
        "*"
      );
    }
  };

  const handleError = () => {
    window.parent.postMessage({ type: "turnstile-error" }, "*");
  };

  const handleExpire = () => {
    window.parent.postMessage({ type: "turnstile-expire" }, "*");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      {ip ? (
        <Turnstile
          siteKey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || ""}
          onSuccess={(token) => handleSuccess(token)}
          onError={handleError}
          onExpire={handleExpire}
          options={{
            theme: "light",
            size: "normal",
          }}
        />
      ) : (
        <div>Loading security check...</div>
      )}
    </div>
  );
};

export default TurnstilePage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/securitycheck',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  